import { authenticatedFetch } from '../../api/apiClient';

const BASE = '/api/v2/users/me/reminders';

async function parseJson(respOrPromise) {
  const resp = await respOrPromise;
  if (!resp || typeof resp.json !== 'function') {
    throw new Error('Reminders API returned an unexpected response');
  }
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const err = new Error(data.error || data.message || `Request failed (${resp.status})`);
    err.detail = data.detail;
    err.status = resp.status;
    throw err;
  }
  return data.data ?? data;
}

function send(path, method, body) {
  const opts = { method };
  if (body !== undefined) {
    opts.headers = { 'Content-Type': 'application/json' };
    opts.body = JSON.stringify(body);
  }
  return parseJson(authenticatedFetch(`${BASE}${path}`, opts));
}

export const listReminders = (view = 'all') => send(`?view=${encodeURIComponent(view)}`, 'GET');
export const listReminderAlerts = (includeDismissed = false) =>
  send(`/alerts?includeDismissed=${includeDismissed ? 'true' : 'false'}`, 'GET').then((d) => d.alerts || []);
export const createReminder = (payload) => send('', 'POST', payload).then((d) => d.reminder);
export const getReminder = (id) => send(`/${id}`, 'GET').then((d) => d.reminder);
export const updateReminder = (id, payload) => send(`/${id}`, 'PATCH', payload).then((d) => d.reminder);
export const deleteReminder = (id, hard = false) =>
  send(`/${id}${hard ? '?hard=true' : ''}`, 'DELETE').then((d) => d.reminder);
export const cancelReminder = (id) => send(`/${id}/cancel`, 'POST').then((d) => d.reminder);
export const pauseReminder = (id) => send(`/${id}/pause`, 'POST').then((d) => d.reminder);
export const resumeReminder = (id) => send(`/${id}/resume`, 'POST').then((d) => d.reminder);
export const snoozeReminder = (id, seconds = 300) =>
  send(`/${id}/snooze`, 'POST', { seconds }).then((d) => d.reminder);
export const dismissReminder = (id, alertId) =>
  send(`/${id}/dismiss`, 'POST', { alertId }).then((d) => d.reminder);
